/**
 * Üzenetmegjelenítő komponens modul
 * @author Erik Banhalmi 2017.06.28.
 */
import angular from 'angular';
import {notificationComponent} from './notification.component';

const MODULE_NAME = 'notification';

export default angular.module(MODULE_NAME, []).component('notification', notificationComponent).name;


